import React from "react";
import { SectionTop } from "../../../index";
import styled from "styled-components";
import { greyLogoImage } from "../../../../assets/images";

export default function PartnersSection() {
	return (
		<SectionWrapper className="partners-section">
			<SectionTop heading="Our Partners" />

			<div className="d-flex justify-content-lg-between align-items-center ">
				{[1, 2, 3, 4]?.map((i) => (
					<img key={i} src={greyLogoImage} alt="" />
				))}
			</div>
		</SectionWrapper>
	);
}

const SectionWrapper = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	/* min-height: 25.5rem; */

	h2 {
		width: 100%;
	}

	div {
		width: 75%;

		@media (max-width: 768px) {
			&:last-child {
				display: grid !important;
				grid-template-columns: repeat(2, 1fr);
				row-gap: 3.1rem;
				column-gap: 3.1rem;

				img {
					width: 6.7rem;
				}
			}
		}
	}
	@media (max-width: 768px) {
		padding: 3.1rem 0 !important;
	}
`;
